export default "__VITE_ASSET__066ac04a__"